export enum ChartLevel {
    Month,
    Week,
    Day
}
